import { alpha } from '@mui/material/styles';

export default function Checkbox(theme) {
  const hoverBg = alpha(theme.palette.primary.main, 0.12);
  const baseColor = alpha(theme.palette.text.primary, 0.45);

  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius / 2,
          color: baseColor,
          transition: theme.transitions.create(['color', 'background-color'], {
            duration: theme.transitions.duration.shorter
          }),
          '&:hover': {
            backgroundColor: hoverBg
          },
          '&.Mui-checked': {
            color: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: hoverBg
            }
          },
          '&.MuiCheckbox-indeterminate': {
            color: theme.palette.primary.main
          }
        }
      }
    }
  };
}
